module.exports = __webpack_public_path__ + "static/media/sharang.66256de6.jpeg";